import api from './index';

const basePath = '/api/v1/downloads';

export default {
  createDownload(params) {
    return api({
      method: 'post',
      url: basePath,
      params,
    });
  },

  getDownload(downloadId, params) {
    return api({
      method: 'get',
      url: `${basePath}/${downloadId}`,
      params,
    });
  },
};
